import { AxiosResponse } from 'axios';
import { getMessageError } from 'utils/helpers';

import { bff } from 'services/bff/client';
import { payout } from 'services/payout';

import { InvoiceStatusResponse, InvoiceDetailsResponse } from './types';

const getInvoiceStatus = async (year: number, month: number) => {
  try {
    const {
      data: { status },
    } = await payout.get<void, AxiosResponse<InvoiceStatusResponse>>(
      `/v1/partners/payments/invoices/year/${year}/month/${month}/status`,
    );

    return status;
  } catch (e) {
    throw new Error(
      getMessageError(
        e,
        'Unexpected error ocurred while retrieving invoice status',
      ),
    );
  }
};

const getInvoiceDetails = async (year: number, month: number) => {
  try {
    const { data } = await bff.get<void, AxiosResponse<InvoiceDetailsResponse>>(
      `/v1/partners/payments/invoices/year/${year}/month/${month}/details`,
    );

    return data;
  } catch (e) {
    throw new Error(
      getMessageError(
        e,
        'Unexpected error ocurred while retrieving invoice details',
      ),
    );
  }
};

export { getInvoiceStatus, getInvoiceDetails };
